export default __webpack_public_path__ + "static/media/ill-no-test.084e5082.svg";